import { jsx as _jsx } from "react/jsx-runtime";
import { Grid } from 'semantic-ui-react';
import './CardGrid.scss';
export const CardGrid = ({ className, jsxCards }) => {
    let listPosition = 0;
    let rowCount = 0;
    let jsxCardsColumns = [];
    const jsxCardsRows = [];
    for (listPosition = 1; listPosition < jsxCards.length + 1; listPosition++) {
        const childKey = jsxCards[listPosition - 1].key;
        jsxCardsColumns.push(_jsx(Grid.Column, { className: "card-grid", children: _jsx("div", { className: "card", children: jsxCards[listPosition - 1] }) }, childKey));
        if ((jsxCardsColumns.length % 3) === 0) {
            jsxCardsRows.push(_jsx(Grid.Row, { children: jsxCardsColumns }, `row${++rowCount}`));
            jsxCardsColumns = [];
        }
    }
    if (jsxCardsColumns.length > 0) {
        jsxCardsRows.push(_jsx(Grid.Row, { children: jsxCardsColumns }, `row${++rowCount}`));
    }
    const clsx = ['card-grid', className !== null && className !== void 0 ? className : ''].join(' ');
    return (_jsx(Grid, { stackable: true, columns: 3, width: 16, className: clsx, children: jsxCardsRows }));
};
